import React, { FC } from 'react'
import { useInView } from 'react-intersection-observer'
import { Toggle as FiltersMenuToggle } from '../../FiltersMenu'
import { ApplicableFilter } from '../../../services/types/services'
import { useSearchStore } from '../../../store/SearchStore'
import { filtersMenuEvent } from '../../../pages/SearchPage/events'
import {
  useSearchAnalytics,
  sanitizeContentType,
} from '../../../pages/SearchPage/analytics'

type Props = {
  onInView?: (inView: boolean) => void
  toggleMenu: () => void
  isMenuOpen: boolean
  appliedFilters: ApplicableFilter[]
}

export const FiltersMenuButton: FC<Props> = ({
  onInView,
  toggleMenu,
  isMenuOpen,
  appliedFilters,
}) => {
  const [ref] = useInView({
    threshold: 0,
    triggerOnce: false,
    onChange: onInView,
  })

  const isLaunchpadAnalytics = useSearchAnalytics()
  const pageContext = useSearchStore(store => store.pageContext)

  const menuAction = isMenuOpen ? 'filters closed' : 'filters opened'

  // Legacy event: apps/explore/find/src/store/middleware/trackEvent.ts
  const menuClickEvent = filtersMenuEvent()
    .withEventData({
      category: `${pageContext.type} action`.toLowerCase(),
      action: menuAction,
      label: pageContext.title.toLowerCase(),
    })
    .withContentData({
      content_type: sanitizeContentType(
        `${pageContext.type} action | ${menuAction} | ${pageContext.title}`,
      ),
    })

  return (
    <FiltersMenuToggle
      onClick={toggleMenu}
      isOpen={isMenuOpen}
      appliedFiltersCount={appliedFilters.length}
      events={isLaunchpadAnalytics ? { onClick: menuClickEvent } : undefined}
      ref={ref}
    />
  )
}
